// IMPORTS
import _ from 'lodash'

const emptyAddress = {
    street: '',
    neighborhood: '',
    city: '',
    state: '',
    country: '',
    postalCode: '',
    additionalInfo: '',
};

let workAddress = _.clone(emptyAddress);

const estadosMexico = [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Campeche',
    'Chiapas',
    'Chihuahua',
    'Ciudad de México',
    'Coahuila',
    'Colima',
    'Durango',
    'Estado de México',
    'Guanajuato',
    'Guerrero',
    'Hidalgo',
    'Jalisco',
    'Michoacán',
    'Morelos',
    'Nayarit',
    'Nuevo León',
    'Oaxaca',
    'Puebla',
    'Querétaro',
    'Quintana Roo',
    'San Luis Potosí',
    'Sinaloa',
    'Sonora',
    'Tabasco',
    'Tamaulipas',
    'Tlaxcala',
    'Veracruz',
    'Yucatán',
    'Zacatecas'
];

function validateAddress() {
    if (!workAddress.state || !estadosMexico.includes(workAddress.state)) {
        throw('El estado es inválido o está vacío.');
    }
    if (!workAddress.city || workAddress.city.trim() === '') {
        throw('La ciudad está vacía.');
    }
    if (!workAddress.neighborhood || workAddress.neighborhood.trim() === '') {
        throw('La colonia está vacía.');
    }
    if (!workAddress.street || workAddress.street.trim() === '') {
        throw('La calle está vacía.');
    }
    if (!workAddress.postalCode || !/^\d{5}$/.test(workAddress.postalCode)) {
        throw('El código postal es inválido o está vacío.');
    }
}

// EXPORTS
export default {
    emptyAddress,
    workAddress,
    validateAddress,
    estadosMexico
};